export default __webpack_public_path__ + "static/media/yuduroboticsLogo.e8913d1d.svg";